import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

const Error403 = () => {
    useEffect(() => {
        document.body.classList.add("error-page");
    });

    const removeClass = () => {
        document.body.classList.remove("error-page");
    }

    return (
        <>
            <div className="main-wrapper">
                <div className="error-box">
                    <h1 className='mb-4'>403</h1>
                    <h3 className="h2 mb-3">
                    Oops! Permission Denied!
                    </h3>
                    <p className="h4 font-weight-normal mb-4">
                        The page you requested is not permitted.
                    </p>
                    <Link to="/dashboard" className="btn btn-primary" onClick={removeClass}>
                        Back to Home
                    </Link>
                </div>
            </div>
        </>
    );
}

export default Error403;